import axios from 'axios';

const api = axios.create({
  baseURL: 'https://docapi.workloob.com/api',
  withCredentials: false
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.data?.message) {
      return Promise.reject(new Error(error.response.data.message));
    }
    return Promise.reject(error);
  }
);

export default api;

